import React, { useState, memo } from 'react';
import { Tooltip, IconButton, useTheme } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { DeleteElementDialog } from '../../Dialogs/deleteElementDialog';

export const ElementButtonDelete = memo(({ id, ids, canvasRef, color, tooltip }) => {
  const [showDeleteNodeDialog, setShowDeleteNodeDialog] = useState(false);
  const theme = useTheme();

  return (
    <>
      <Tooltip title={tooltip ? tooltip : "Delete node"}>
        <IconButton size="small" onClick={() => setShowDeleteNodeDialog(true)} sx={{ color: theme.palette.common.white }}>
          <DeleteIcon sx={{ fontSize: 15, color: color || theme.palette.common.white }} />
        </IconButton>
      </Tooltip>
      <DeleteElementDialog id={id} ids={ids} open={showDeleteNodeDialog} handleClose={() => setShowDeleteNodeDialog(false)} refreshLayout={() => canvasRef?.current?.setLayout()} />
    </>
  );
});